<template>
  <div class="text-xs text-white bg-red-500 p-4 w-auto">
    <span class="inline">
      <hireful-icon icon="warning" class="h-6 w-6 inline"></hireful-icon>
    </span>
    <span class="inline pl-2">
    {{msg}}
    </span>
  </div>
</template>

<script>
import hirefulIcon from '@/components/hireful-icon'
export default {
  name: 'hireful-notification',
  components: {
    hirefulIcon
  },
  props: {
    msg: {
      type: String,
      default: ''
    }
  }
}
</script>

<style>

</style>
